import React from "react";
import {
  getTrainingMethodLabel,
  getTrainingMethodColor,
} from "../../utils/exerciseUtils";

interface TrainingMethodBadgeProps {
  trainingMethod: string;
  className?: string;
}

const TrainingMethodBadge: React.FC<TrainingMethodBadgeProps> = ({
  trainingMethod,
  className = "",
}) => {
  if (!trainingMethod) return null;

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold ${getTrainingMethodColor(
        trainingMethod
      )} ${className}`}
    >
      {getTrainingMethodLabel(trainingMethod)}
    </span>
  );
};

export default TrainingMethodBadge;
